import React from 'react';

import styles from './CardImage.module.scss';

const CardImage = ({image}) => (
    <div className={styles.cardImage} style={{ backgroundImage: `url(/cards/${image}.jpg)` }}></div>
)

export default CardImage;